function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.725 17.087h12.55c1.283 0 2.083-1.392 1.442-2.5L11.442 3.744a1.666 1.666 0 00-2.884 0L2.283 14.586c-.641 1.109.159 2.5 1.442 2.5zM10 11.253a.836.836 0 01-.833-.833V8.753c0-.458.375-.833.833-.833.458 0 .833.375.833.833v1.667a.836.836 0 01-.833.833zm-.833 3.333h1.666V12.92H9.167v1.666z"
});

function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgIconWarning;